import React from 'react';
import TextField from "@mui/material/TextField";
import  Helpers  from '@sistemas.mundo/helper-functions';
import InputAdornment from '@mui/material/InputAdornment';

const CustomTextField = (
    {
        name,
        register,
        required,
        type,
        label,
        value,
        size = 'medium',
        onChange = null,
        onBlur = null,
        onKeyDown = null,
        disabled = false,
        rows = null,
        multiline = false,
        hashError = { value: false, message: '' },
        minLength = 0,
        maxLength = null,
        pattern = null,
        errorMessage = null,
        autoComplete = 'off',
        preventSubmitOnEnter = true,
        icon=false,
        placeholder=""
    }) => {
    /**
    * Retorna el pattern correspondiente para el campo
    * @param {*} campo 
    * @returns 
    */
    const getCampoPattern = () => {
        if (type === 'number' && !pattern) {
            return Helpers.formPatterns.numero;
        }
        return pattern ?? '';
    }

    const onChangeCampo = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    }

    const onBlurCampo = (event) => {
        if (onBlur) {
            onBlur(event.target.value);
        }
    }

    /**
     * previene que se envie el formulario al presionar enter
     * @param {*} event 
     */
    const handleOnKeyDown = (event) => {
        if (preventSubmitOnEnter && event.keyCode === 13 && type!=="textarea") {
            event.preventDefault()
            event.stopPropagation();
        }
        // Retorna la acción onKeyDown del campo al componente principal
        if (onKeyDown) {
            onKeyDown(event);
        }
    }
 
    return (
        <TextField
            InputLabelProps={{ shrink: value ? true : false }}
            size={size}
            variant="standard"
            fullWidth={true}
            type={type === 'number' ? 'text' : type}
            //label={label}
            placeholder={placeholder}
            rows={rows ? rows : null}
            multiline={multiline ? multiline : false}
            disabled={disabled ? disabled : false}
            error={hashError ? hashError.value : false}
            helperText={hashError ? hashError.message : ''}
            value={value}
            id={name}
            {...register(name, {
                required: required,
                minLength: minLength,
                maxLength: maxLength,
                pattern: {
                    value: getCampoPattern(),
                    message: errorMessage ?? Helpers.formErrorMessages.patternErrorMessage(label),
                }
            })}
            InputProps={ icon ? {
                startAdornment: (
                  <InputAdornment position="start">
                    {icon}
                  </InputAdornment>
                ),
                sx:{background:'#00657d33', padding: "0.3rem", paddingLeft: "1rem",borderRadius:'10px',opacity:1,fontFamily: "Montserrat"},
                disableUnderline: true
              } : {sx:{background:'#00657d33', padding: "0.3rem", paddingLeft: "1rem",borderRadius:'10px',opacity:1,fontFamily: "Montserrat"}, disableUnderline: true} }
            onChange={onChangeCampo}
            onBlur={onBlurCampo}
            autoComplete={autoComplete ? 'on' : 'off'}
            onKeyDown={e => handleOnKeyDown(e)}
        />
    );
}

export default CustomTextField;
